import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import AccordionDetails from '@mui/material/AccordionDetails';

const StyledAccordionDetails = styled(AccordionDetails)` 
  ${ComponentStyles}
`;

StyledAccordionDetails.propTypes = {
  theme: PropTypes.object
};

export default StyledAccordionDetails;
